import { render, staticRenderFns } from "./achievementList.vue?vue&type=template&id=e9fafae6&scoped=true"
import script from "./achievementList.vue?vue&type=script&lang=js"
export * from "./achievementList.vue?vue&type=script&lang=js"
import style0 from "./achievementList.vue?vue&type=style&index=0&id=e9fafae6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fafae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9fafae6')) {
      api.createRecord('e9fafae6', component.options)
    } else {
      api.reload('e9fafae6', component.options)
    }
    module.hot.accept("./achievementList.vue?vue&type=template&id=e9fafae6&scoped=true", function () {
      api.rerender('e9fafae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/comps/achievementList.vue"
export default component.exports